import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, Inject, Optional, ViewChildren, QueryList } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { IUser } from '@app/core/interfaces/user/IUser';
import { UserService } from '@app/core/services/UserService';
import { IInvoice } from '@app/core/interfaces/IInvoice';
import { InvoiceService } from '@app/core/services/InvoiceService';
import { ICompany } from '@app/core/interfaces/ICompany';
import { CompanyService } from '@app/core/services/CompanyService';
import { TransactionLogService } from '@app/core/services/TransactionLogService';
import { IContact } from '@app/core/interfaces/IContact';
import { ITransactionLog } from '@app/core/interfaces/invoice/ITransactionLog';
import { AuthenticationService } from '@app/core/services/AuthenticationService';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';
import { Subject } from 'rxjs';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@app/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { IFile } from '@app/core/interfaces/IFile';
import { FileService } from '@app/core/services/FileService';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';

export interface TransLogData {
    name: string;
    id: number;
    money: number;
    date: string;
    ManualDiscount: any;
    FeeDescription: any;
    PartialTotalAmount: any;
    DeductionsTotalAmount: any;
    AllowancesTotalAmount: any;
    MileageTotalAmount: any;
    GrossSalary: any;
    EmployerTaxAmount: any;
    MunicipalityTaxAmount: any;
    NetSalary: any;
    TotalPayout: any;
    ServiceFee: any;
    Invoice: any;
    ReminderFee: any;
    InkassoFee: any;
    KronofogdenFee: any;
    CustomFee: any;
    TotalInvoiceAmount: any;
    PaidTotal: any;
    TotalInvoiceAmountIncVat: any;
    TotalVatAmount: any;
    InvoiceFeeReceiver: any;
    InvoiceFeeMember: any;
  InvoiceFee: any;
  isMobile: any;
  sortData: any;
  ExchangeFee: any;
  IsPreliminary: any;
  IsPayoutTransLog: any; 


}

@Component({
  standalone: false,
    selector: 'anms-transaction-logs',
  templateUrl: './transaction-logs.component.html',
  styleUrls: ['./transaction-logs.component.css'],
})

export class TransactionLogsComponent implements OnInit, OnDestroy {

  private readonly pageSizeStorageKey = "transactionLogsPageSize";
  public readonly pageSizeOptions = [5, 20, 50, 100, 500];
  public isAdmin: boolean = false;
  transactionLogs: Array<ITransactionLog>;
  expensesTotalAmount = 0;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  //@ViewChild(MatSort, { static: true }) sort: MatSort;
 // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataSource: MatTableDataSource<IInvoice>;
  dataSourceAdmin: MatTableDataSource<ITransactionLog>;
  //@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  isLoading: boolean = true;
  private unsubscribe$: Subject<void> = new Subject<void>();
  private cancelInvoiceRequest$ = new Subject<void>();
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  displayedColumns = ['invoicenumber', 'customer', 'payment', 'payout'];
  displayedColumnsAdmin = [];
  user: any;
  invoiceData: Array<any>;
  statuses = [];
  payoutStatuses: any;
  selectedFilterStatus: any = { Id: 0, Name: 'Alla fakturor' };
  filter: string;
  sortedData;
  public listLength = 0;
  public pageSize = 10;
  public search: string;
  searchUpdate = new Subject<string>();
  PaymentTransLog: any;
  PayoutTransLog: any;
  isMobile: any;
  Invoice: any;
    
  constructor(
    public dialog: MatDialog,
    private invoiceService: InvoiceService,
    private transactionLogService: TransactionLogService,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private loadingService: LoadingBarService,
    private userService: UserService,
    private fileService: FileService,
    private changeDetectorRef: ChangeDetectorRef) {
    this.dataSource = new MatTableDataSource<IInvoice>(this.invoiceData);
    this.dataSourceAdmin = new MatTableDataSource<ITransactionLog>(this.transactionLogs);

    // Debounce search.
    this.searchUpdate.pipe(
      debounceTime(600),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$))
      .subscribe(value => {
        this.paginator.pageIndex = 0;
        this.filter = value.toString();
        this.getInvoices(null, 0, this.paginator.pageSize, value.toString());
      });
  }


  ngOnInit() {
        
      this.userLoaded();
  }

  userLoaded() {
    this.user = this.authenticationService.userData;
    this.isAdmin = this.userService.userHasRole("admin");
    this.setTableColumns(this.isAdmin);

    const savedPageSize = Number(this.localStorageService.getItem(this.pageSizeStorageKey));
    if (this.pageSizeOptions.includes(savedPageSize)) {
      this.pageSize = savedPageSize;
    }

    if (this.isAdmin) {
      this.loadTransactions();
    }

    // Default selected item from storage
    var defaultItem = this.localStorageService.getItem("filterStatusDefault");
    if (defaultItem && this.isAdmin) {
      var item = JSON.parse(defaultItem);
      this.selectedFilterStatus = { Id: item.Id, Name: item.Name };

      this.getInvoices([item.Id], 0, this.pageSize, this.filter);

    }
    else {
      this.getInvoices(null, 0, this.pageSize, this.filter);
    }

   

  }

  setTableColumns(isAdmin: boolean) {
      if (isAdmin) {
        this.displayedColumns = ['invoicenumber', 'customer', 'user', 'payment', 'payout'];
      }
  }
    
  applyFilter(filterValue: string) {
      filterValue = filterValue.trim();         // Remove whitespace
      filterValue = filterValue.toLowerCase();  // Datasource defaults to lowercase matches
      this.dataSource.filter = filterValue;
  }

  onPaginatorChange(paginator: any) {
    this.pageSize = paginator.pageSize;
    this.localStorageService.setItem(this.pageSizeStorageKey, this.pageSize);
    this.loadingService.start();
    this.getInvoices(null, paginator.pageIndex, this.pageSize, this.filter);
  }

  openInvoiceDocument(file: IFile, event?: Event) {
    event?.preventDefault();
    this.fileService.openFile(file);
  }

  getInvoices(statuses: Array<number> = null, pageIndex: number, pageSize: number, filter: string) {
    this.cancelInvoiceRequest$.next();
    
    this.isLoading = true;

    // All invoices selected
    if (statuses != null && statuses.length == 1 && statuses[0] == 0) {
      statuses = null;
        
    }

    this.invoiceService.getInvoicesWithTransLogs(statuses, pageIndex, pageSize, filter)
      .pipe(takeUntil(this.cancelInvoiceRequest$), takeUntil(this.unsubscribe$))
      .subscribe(value => this.onInvociesRetrieved(value),
        error => {
          console.log(error);
          this.isLoading = false;
          this.loadingService.complete();
        }
    );
    
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.cancelInvoiceRequest$.complete();
  }

  onInvociesRetrieved(response: any) {

    for (var i = 0; i < response.Invoices.length; i++) {
      if (response.Invoices[i].Status != undefined)
        response.Invoices[i].Status.Id = response.Invoices[i].Status.Id.toString();
    }

    this.invoiceData = response.Invoices;
    this.listLength = response.TotalInvoices;
    this.dataSource = new MatTableDataSource(this.invoiceData);
    //this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.sort.toArray()[0];

    for (var i = 0; i < this.invoiceData.length; i++) {
      if (this.invoiceData[i].ExchangeRateInvoicePaid != 0) {
        this.invoiceData[i].TotalVatAmount *= this.invoiceData[i].ExchangeRateInvoicePaid;
      }
    }

    // Set up custom search
    this.dataSource.filterPredicate = function (data, filter: string): boolean {
        
      return (data.Status != null ? data.Status.Name.toLowerCase().includes(filter) : '') ||
        (data.Id == undefined ? '' : data.Id.toString().toLowerCase().includes(filter)) ||
        (data.InvoiceNumber == undefined ? '' : data.InvoiceNumber.toString().toLowerCase().includes(filter)) ||
        (data.Customer != null ? data.Customer.Name.toLowerCase() : '').includes(filter) ||
        (data.Created.toString().toLowerCase()).includes(filter) ||
        ((data.User == null || data.User == null) ? '' : data.User.FirstName.toLowerCase() + ' ' + data.User.LastName.toLowerCase()).includes(filter);

    };

    this.isLoading = false;
    this.loadingService.complete();
    this.changeDetectorRef.detectChanges();
      
  }

  loadTransactions() {
    //this.transactionLogService.getTransactionLogs()
    //  .subscribe(transactions => this.transactionsLoaded(transactions),
    //    error => alert("An error occured!"));
  }

  transactionsLoaded(transactions: Array<ITransactionLog>) {

    this.transactionLogs = transactions;
    this.dataSourceAdmin = new MatTableDataSource<ITransactionLog>(this.transactionLogs);
    //this.dataSourceAdmin.paginator = this.paginator.toArray()[1];
    this.dataSourceAdmin.sort = this.sort.toArray()[1];

  }

  deleteTransactionLog(id: number) {
    var result = confirm("Vill du radera transaktionsraden?");

    if (result) {
      this.transactionLogService.deleteTransactionLog(id)
        .subscribe(response => this.onDeleteFinished(response), error => console.log(error));

    }
  }

  onDeleteFinished(response: any) {
    this.loadTransactions();
  }

  sortData(sort: Sort) {
    const data = this.invoiceData.slice();

    //if (!sort.active || sort.direction == '') {
    //  this.sortedData = data;
    //  return;
    //}
    this.sortedData = data.sort((a, b) => {

      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'id': return this.compare(a.Id, b.Id, isAsc);
        case 'customer': return this.compare(a.InvoiceNumber, b.InvoiceNumber, isAsc);
        case 'invoicenumber': return this.compare(a.Customer != null ? a.Customer.Name : '', b.Customer.Name != null ? b.Customer.Name : '', isAsc);
        case 'payment': return this.compare(a.PayoutStatus.Name, b.PayoutStatus.Name, isAsc);
        case 'payout': return this.compare(a.Status.Name, b.Status.Name, isAsc);
        default: return 0;
      }
    });

    this.dataSource.data = this.sortedData;
  }

  getPrelPayoutDate(paymentDue: Date, isExpress: boolean, logCreated?: Date, invoiceCreated?: Date) {
    const paymentDueDate = this.toValidDate(paymentDue);

    if (!isExpress) {
      if (!paymentDueDate) {
        return null;
      }

      const prelPayoutDate = new Date(paymentDueDate);
      prelPayoutDate.setDate(prelPayoutDate.getDate() + 1);
      return prelPayoutDate;
    }

    const baseDate = this.toValidDate(logCreated) || this.toValidDate(invoiceCreated) || paymentDueDate;
    if (!baseDate) {
      return null;
    }

    return this.getNextBusinessDay(baseDate);
  }

  toValidDate(value: any) {
    if (!value) {
      return null;
    }

    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  getNextBusinessDay(date: Date) {
    const next = new Date(date);
    next.setDate(next.getDate() + 1);

    while (next.getDay() === 0 || next.getDay() === 6) {
      next.setDate(next.getDate() + 1);
    }

    return next;
  }

  getPaymentTransactionLog(invoice: any) {
    return this.getLatestTransactionLogByType(invoice?.TransactionLogs, [3, 1]);
  }

  getPayoutTransactionLog(invoice: any) {
    return this.getLatestTransactionLogByType(invoice?.TransactionLogs, [4, 2]);
  }

  private getLatestTransactionLogByType(transactionLogs: Array<any>, typeIds: Array<number>) {
    if (!transactionLogs || transactionLogs.length === 0) {
      return null;
    }

    for (const typeId of typeIds) {
      const activeLogs = transactionLogs.filter(log =>
        log &&
        log.Inactive === false &&
        log.Type &&
        Number(log.Type.Id) === typeId);

      if (activeLogs.length > 0) {
        return this.getLatestTransactionLog(activeLogs);
      }
    }

    return null;
  }

  private getTransactionLogSortTime(transactionLog: any) {
    const date = this.toValidDate(transactionLog.Updated) || this.toValidDate(transactionLog.Created);
    return date ? date.getTime() : 0;
  }

  private getLatestTransactionLog(transactionLogs: Array<any>) {
    return transactionLogs.sort((a, b) => {
      const aTime = this.getTransactionLogSortTime(a);
      const bTime = this.getTransactionLogSortTime(b);

      if (aTime !== bTime) {
        return bTime - aTime;
      }

      return (Number(b.Id) || 0) - (Number(a.Id) || 0);
    })[0];
  }

  compare(a, b, isAsc) {
    console.log((a < b ? -1 : 1) * (isAsc ? 1 : -1));
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  openDialog(action, invoice) {

    invoice.action = action;

    const dialogRef = this.dialog.open(TransactionLogMemberDialog, {
        
        width: '750px',
        data: invoice
    });
    dialogRef.afterClosed()
    console.log('The dialog is open');
  }

  openDialogAdmin(action, obj) {

    obj.action = action;
    const dialogRef = this.dialog.open(TransactionLogAdminDialog, {

      width: '750px',
      data: obj
    });
    dialogRef.afterClosed()
    console.log('The dialog is open');
  }


}

@Component({
  standalone: false,
  selector: 'transaction-log-member-dialog',
  templateUrl: 'transaction-log-member-dialog.html',
})
export class TransactionLogMemberDialog {
  invoice: any;
  TransactionLog: any;


  constructor(

    public dialogRef: MatDialogRef<TransactionLogMemberDialog>,

    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

      // Datat kommer in via parametern data och placeras i den lokala egenskapen invoice
      this.invoice = { ...data };
      
    // I den inskickade fakturaunderlaget så lade vi till parametern action som vi nu kontrollerar och sedan väljer trans-rad efter
    if (this.invoice.action == 'payment') {
      this.TransactionLog = this.getPaymentTransactionLog(this.invoice);
    }
    else if (this.invoice.action == 'payout') {
      this.TransactionLog = this.getPayoutTransactionLog(this.invoice);
      }

    }

    private getPaymentTransactionLog(invoice: any) {
      if (!invoice?.TransactionLogs || invoice.TransactionLogs.length === 0) {
        return null;
      }

      return this.getLatestTransactionLogByType(invoice.TransactionLogs, [3, 1]);
    }

    private getPayoutTransactionLog(invoice: any) {
      if (!invoice?.TransactionLogs || invoice.TransactionLogs.length === 0) {
        return null;
      }

      return this.getLatestTransactionLogByType(invoice.TransactionLogs, [4, 2]);
    }

    private getLatestTransactionLogByType(transactionLogs: Array<any>, typeIds: Array<number>) {
      for (const typeId of typeIds) {
        const activeLogs = transactionLogs.filter(log =>
          log &&
          log.Inactive === false &&
          log.Type &&
          Number(log.Type.Id) === typeId);

        if (activeLogs.length > 0) {
          return this.getLatestTransactionLog(activeLogs);
        }
      }

      return null;
    }

    private getTransactionLogSortTime(transactionLog: any) {
      const updated = transactionLog.Updated ? new Date(transactionLog.Updated).getTime() : 0;
      const created = transactionLog.Created ? new Date(transactionLog.Created).getTime() : 0;

      return updated || created || 0;
    }

    private getLatestTransactionLog(transactionLogs: Array<any>) {
      return transactionLogs.sort((a, b) => {
        const aTime = this.getTransactionLogSortTime(a);
        const bTime = this.getTransactionLogSortTime(b);

        if (aTime !== bTime) {
          return bTime - aTime;
        }

        return (Number(b.Id) || 0) - (Number(a.Id) || 0);
      })[0];
    }

    // Stäng popupen och returnera ev data
    closeDialog() {
        this.dialogRef.close(null);
    }

}


@Component({
  standalone: false,
  selector: 'transaction-log-admin-dialog',
  templateUrl: 'transaction-log-admin-dialog.html',
})
export class TransactionLogAdminDialog {
  action: string;
  local_data: any;
  Invoice: any;
  TransactionLog: any;


  constructor(

    public dialogRef: MatDialogRef<TransactionLogAdminDialog>,

    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log("Öppnad faktura")
    console.log(data);
    this.local_data = { ...data };
    this.action = this.local_data.action;
  }

  closeDialog() {
    this.dialogRef.close();
    console.log('The dialog was closed');
  }

}





